<template>
  <a href="#" :data-testid="'pro-link-'+id" v-bind="$attrs" v-on="$listeners" @click="onClick()">
    <img v-if="! payingUser && showProRibbon"
          src="@img/pro-ribbon.png" class="img-pro-ribbon" :data-testid="'img-pro-ribbon-' + id">
    <i :class="icon" data-toggle="tooltip" data-placement="top" :title="title"></i>
    <span class="owner-action-label"><slot></slot></span>
  </a>
</template>

<script>
export default  {
  props: ["title", "id", "icon", "showProRibbon"],
  computed: {
    // User can be not "paying" AND not "free", if they have a trial.
    payingUser: function() {
      return (this.$store.state.currentOrganization.attributes.is_paying == true);
    },
    freeUser: function() {
      return (this.$store.state.currentOrganization.attributes.free == true);
    }
  },
  methods: {
    onClick: function(event) {
      this.$emit(this.freeUser ? "free-click" : "pro-click", event);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/packs/application.scss';

  .owner-action-label {
    font-size: 0.75rem;
  }

  .img-pro-ribbon {
    width: 40px;
    position: absolute;
    left: 8em;
    top: 0;
  }
</style>
